import EmailValidationResult from '../models/EmailValidationResult';
import { validationApiService } from './ValidationApiService';
import { store } from '../store';

class EmailValidationService {
  private static serviceInstance = new EmailValidationService();

  public static get instance(): EmailValidationService {
    return this.serviceInstance;
  }

  public async startCompleteEmailValidation(emailAddress: string) {
    const startDate = new Date();
    const startValidation = this.createValidationResult(emailAddress, startDate, null, null);
    await store.dispatch('personalDetailsModule/submitEmailValidationResult', startValidation);

    try {
      const response = await validationApiService.isEmailValid(emailAddress, true);
      const endDate = new Date();
      const endValidation = this.createValidationResult(emailAddress, startDate, endDate, response);
      await store.dispatch('personalDetailsModule/submitEmailValidationResult', endValidation);
    } catch (error) {
      console.error('Error validating email:', error);
    }
  }

  private createValidationResult(emailAddress: string, startDate: Date, endDate: Date | null, isValid: boolean | null) {
    const validationResult = new EmailValidationResult();
    validationResult.emailAddress = emailAddress;
    validationResult.isValid = isValid;
    validationResult.validationStarted = startDate;
    validationResult.validationEnded = endDate;
    return validationResult;
  }

  public async isEmailValidated(): Promise<boolean> {
    const emailValidationResult = await store.getters['personalDetailsModule/emailCapture'];

    if (!emailValidationResult || !emailValidationResult.emailAddress) {
      return false;
    }

    if (emailValidationResult.validationInProgress()) {
      return false;
    }

    if (emailValidationResult.isValid === true) {
      return true;
    }

    return false;
  }
}

const emailValidationService = EmailValidationService.instance;
export default emailValidationService;
